import React from "react";
import BorderSettings from "fantastic/components/common/controls/border/Settings";

export default ({ onChange, node, scrollToIfNeeded }) => {
  const params = {
    onChange,
    scrollToIfNeeded,
    color: { field: "css_border_color", value: node.css_border_color },
    style: { field: "css_border_style", value: node.css_border_style },
    size: { field: "css_border_width", value: node.css_border_width },
    radius: { field: "css_border_radius", value: node.css_border_radius }
  };
  return <BorderSettings {...params} />;
};
